module.exports = __webpack_public_path__ + "img/IMG_2416.22154e98.jpg";